import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MqttContext } from "../mqtt/MqttContext";
import "./screen.css";
import "./styles.css";
const LOGIN_API_URL = process.env.REACT_APP_LOGIN_API_URL;
function Login() {
  const [username, setusername] = useState("");
  const [password, setpassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false); // State for password visibility
  const navigate = useNavigate();
  const { subscribe } =
    useContext(MqttContext);
    useEffect(() => {
    subscribe(`dssp/deviceData/#`);
      // eslint-disable-next-line
    }, []);
  const login = async () => {
    fetch(`${LOGIN_API_URL}/login.php`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        lg_email: username?.toLowerCase(),
        lg_password: password,
      }),
    })
      .then((response) => response.json())
      .then((responseData) => {
        localStorage.setItem("role", responseData.Role);
        localStorage.setItem("loginId", responseData.loginId);
        if (responseData.status === "Login Successfully") {
          // Notification.requestPermission().then((permission) => {
          //   if (permission === "granted") {
          //     requestFCMToken();
          //   } else {
          //     console.log("Notification permission denied.");
          //   }
          // });
          navigate("/dashboard");
        } else {
          window.alert(responseData.status);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const checklogin = async () => {
    const id = localStorage.getItem("loginId");
    if (id) {
      navigate("/dashboard");
    }
  };

  const location = useLocation();

  useEffect(() => {
    checklogin();
    // eslint-disable-next-line
  }, [location]);

  const togglePasswordVisibility = () => {
    setPasswordVisible((prev) => !prev); // Toggle password visibility
  };

  return (
    <div
      style={{
        height: "100vh",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "linear-gradient(to right, #fff, #fff)",
        fontFamily: "'Inter', sans-serif",
      }}
    >
      <div
        style={{
          width: "90%",
          maxWidth: "420px",
          padding: "40px 30px",
          borderRadius: "16px",
          background: "rgba(255, 255, 255, 0.05)",
          backdropFilter: "blur(16px)",
          WebkitBackdropFilter: "blur(16px)",
          border: "1px solid rgba(255, 255, 255, 0.1)",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.25)",
          color: "#ffffff",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "30px" }}>
          <img
            src={require("../img/logo1.png")}
            alt="Logo"
            style={{ width: "60%", borderRadius: "8px" }}
          />
        </div>

        <div className="input-container">
          <input
            type="text"
            value={username}
            onChange={(e) => setusername(e.target.value)}
            required
            style={{
              width: "100%",
              padding: "12px",
              background: "transparent",
              border: "1px solid #aaa",
              borderRadius: "8px",
              color: "#000",
              marginBottom: "20px",
              fontSize: "16px",
            }}
            placeholder="Email"
          />
        </div>

        <div className="input-container" style={{ position: "relative" }}>
          <input
            type={passwordVisible ? "text" : "password"} // Toggle the password visibility
            value={password}
            onChange={(e) => setpassword(e.target.value)}
            required
            style={{
              width: "100%",
              padding: "12px",
              background: "transparent",
              border: "1px solid #aaa",
              borderRadius: "8px",
              color: "#000",
              marginBottom: "30px",
              fontSize: "16px",
            }}
            placeholder="Password"
          />
          {/* Eye icon for toggling password visibility */}
          <img
            src={
              passwordVisible
                ? require("../img/view.png")
                : require("../img/hide.png")
            }
            alt="Toggle Visibility"
            onClick={togglePasswordVisibility}
            style={{
              position: "absolute",
              right: "12px",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              width: "20px", // Adjust size as needed
              height: "20px",
            }}
          />
        </div>

        <button
          onClick={login}
          className="btn btn-outline-light"
          style={{
            width: "100%",
            padding: "12px",
            fontSize: "16px",
            fontWeight: "600",
            background: "#8ec5fc",
            border: "none",
            borderRadius: "10px",
            color: "#fff",
            boxShadow: "0 4px 12px rgba(0, 119, 255, 0.4)",
            transition: "all 0.3s ease",
            backgroundColor: "#005fcc",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.background = "#8ec5fc")}
          onMouseLeave={(e) => (e.currentTarget.style.background = "#005fcc")}
        >
          Log In
        </button>
      </div>
    </div>
  );
}

export default Login;
